import { Provider } from '@angular/core';
import { provideTranslocoScope } from '@jsverse/transloco';

/**
 * Diccionario de NEXUS, cargado al entrar en cualquiera de sus módulos.
 *
 * <p><b>Por qué un scope y no el JSON global.</b> PartnerCore mantiene sus ~3.300 claves en
 * `assets/i18n/{lang}.json`, que ya pesa 178 KB por idioma. NEXUS aporta otras ~3.500: meterlas
 * ahí duplicaría ese archivo y lo descargaría entero cualquiera que abra el login, aunque nunca
 * vaya a entrar en un módulo de NEXUS.
 *
 * <p><b>Por qué uno solo y no uno por módulo.</b> Los módulos comparten componentes: la pantalla
 * de Tareas renderiza además el árbol de Espacios, las vistas de Visualizaciones, el hilo de
 * comentarios de Colaboración y el resumen de DevOps. Con un scope por librería, esa ruta tendría
 * que declarar cinco —y bastaría añadir un componente compartido para que aparecieran claves sin
 * traducir en producción, sin que nada fallara en el build. Un único diccionario elimina esa clase
 * de error a cambio de descargar de una vez lo que el usuario acabará usando de todos modos.
 *
 * <p>Se declara en la ruta padre `nexus`, así que se hereda en todas sus hijas.
 *
 * <p>El {@code TranslocoHttpLoader} resuelve la ruta sin cambios: Transloco le pasa `nexus/es`
 * como idioma y el loader pide `assets/i18n/nexus/es.json`.
 *
 * @example
 * {
 *   path: 'nexus',
 *   providers: [nexusScope()],
 *   children: [ ... ],
 * }
 *
 * Y en las plantillas: {{ 'nexus.tareas.nuevaTarea' | transloco }}
 */
export function nexusScope(): Provider {
  return provideTranslocoScope({ scope: 'nexus', alias: 'nexus' });
}
